import { render } from "./SmsServiceParameter.vue?vue&type=template&id=53e94d84&scoped=true"
import script from "./SmsServiceParameter.vue?vue&type=script&lang=ts"
export * from "./SmsServiceParameter.vue?vue&type=script&lang=ts"

import "./SmsServiceParameter.vue?vue&type=style&index=0&id=53e94d84&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53e94d84"

export default script